import React, { useState } from "react";
import { Button, Cascader } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { getGroupOptions } from "@Components/groups/GroupUtils";
import { IUserGroupDetails } from "@Models/IUserGroupDetails";
import { QueryKeys } from "@Constants";
import appQueryClient from "@AppQueryClient";

interface ICascaderOptions {
    label: string;
    value: string;
    children?: ICascaderOptions[];
}

interface IProps {
    addAction: (groupId: string) => void;
}

const GroupMenu: React.FC<IProps> = ({ addAction }: IProps) => {
    const [options, setOptions] = useState<ICascaderOptions[]>([]);
    const allGroups = appQueryClient.getQueryData<IUserGroupDetails[]>([QueryKeys.UserGroups]);

    const onDropdownVisibleChange = (open: boolean) => {
        if (!open) {
            return;
        }
        setOptions(getGroupOptions(allGroups));
    };

    return options?.length ? (
        <span
            className="assignment-menu"
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <Cascader
                options={options}
                value={[]}
                onDropdownVisibleChange={(value) => {
                    onDropdownVisibleChange(value);
                }}
                onChange={(val) => addAction(val[0])}
            >
                <Button className="secondary" icon={<PlusOutlined />}>
                    Add Group
                </Button>
            </Cascader>
        </span>
    ) : null;
};
export default GroupMenu;
